module.exports = __webpack_public_path__ + "img/payment_steps_completed.ff38307c.svg";